interface CloudFormationIconProps {
  className?: string;
}

export function CloudFormationIcon({ className = "" }: CloudFormationIconProps) {
  return (
    <svg
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <g fill="currentColor">
        <path d="M9.1 44.262l.447.507 22.573 6.4.102-3.966-15.8-3.967-.774-.28-6.54 1.307"/>
        <path d="M54.9 44.262l-23.053 7.695-.07-4.755 15.8-3.967.7-.775 6.624 1.803"/>
      </g>
      <path d="M31.777 17.08l15.8 3.684 6.953-.33.36-.697-22.026-7.93-1.095 5.27" fill="currentColor" opacity="0.5"/>
      <path d="M16.413 43.235L9.1 44.262l-.204-.76V20.536l.204-.8 6.608.5.705.536v22.47" fill="currentColor"/>
      <path d="M32.222 17.08l-15.8 3.684L9.1 19.737l.276-.433L32.12 12.83l.102 4.248" fill="currentColor" opacity="0.5"/>
      <path d="M31.968 0L5.713 13.252l.013 37.502L31.968 64l.4-.594V.77zM24.3 48.82L9.1 44.262V19.737l15.2-4.557zm23.295-5.587l7.313 1.028.4-.725V20.434l-.4-.697-7.313 1.027v22.47" fill="currentColor" opacity="0.7"/>
      <path d="M31.968 64l26.306-13.245.013-37.502L31.968 0zm7.74-48.82l15.2 4.557v24.525l-15.2 4.56z" fill="currentColor"/>
    </svg>
  );
}
